import React, { FC } from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { formatNumberMetric } from '../../utils/commonUtils';

interface IKPICardProps {
	title: string;
	value: number;
	icon: React.ElementType;
	cardColor?: string;
	iconColor?: string;
	textColor?: string;
}

const KPICard: FC<IKPICardProps> = ({ title, value, icon: Icon, cardColor, iconColor, textColor }) => {
  return (
    <Card
      sx={{
        bgcolor: cardColor || 'background.paper',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: 3,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              p: 1.25,
              borderRadius: 1.5,
              bgcolor: iconColor || 'grey.600',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 40,
              minHeight: 40,
            }}
          >
            <Icon sx={{ color: 'white', fontSize: 20 }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                mb: 0.25,
                fontSize: '0.75rem',
                fontWeight: 500,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: textColor || 'text.primary',
                fontWeight: 700,
                fontSize: '1.5rem',
                lineHeight: 1.2,
              }}
            >
              {formatNumberMetric(value)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default KPICard;
